import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ApplyIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20.919"}
      height={height || "19.647"}
      viewBox="0 0 20.919 19.647"
    >
      <g
        id="Apply_Tag"
        data-name="Apply Tag"
        transform="translate(-287.917 -178.917)"
        opacity="0.8"
      >
        <g id="Group_111" data-name="Group 111">
          <path
            id="Path_1054"
            data-name="Path 1054"
            d="M288.667,181.354a1.687,1.687,0,0,1,1.687-1.687h7.176a1.934,1.934,0,0,1,1.193.494l7.449,7.449a1.687,1.687,0,0,1,0,2.386L299,197.172a1.687,1.687,0,0,1-2.386,0l-7.449-7.449a1.934,1.934,0,0,1-.494-1.193Zm3.25,3.25a1.688,1.688,0,1,0,1.687-1.687A1.687,1.687,0,0,0,291.917,184.6Z"
            fill="none"
            stroke={color || "#bbb"}
            strokeWidth="1.5"
          />
        </g>
        <g id="Group_113" data-name="Group 113">
          <circle
            id="Ellipse_89"
            data-name="Ellipse 89"
            cx="5.204"
            cy="5.204"
            r="5.204"
            transform="translate(298.287 183.279)"
            fill="#fff"
          />
          <g id="Group_112" data-name="Group 112">
            <path
              id="Path_1055"
              data-name="Path 1055"
              d="M308.836,188.183a5.5,5.5,0,1,1-5.5-5.5A5.5,5.5,0,0,1,308.836,188.183Zm-2.306-.621a.267.267,0,0,0-.266-.266h-2.04v-2.041a.268.268,0,0,0-.267-.266h-1.242a.267.267,0,0,0-.266.266V187.3h-2.04a.267.267,0,0,0-.266.266V188.8a.267.267,0,0,0,.266.266h2.04v2.04a.267.267,0,0,0,.266.266h1.242a.267.267,0,0,0,.267-.266v-2.04h2.04a.267.267,0,0,0,.266-.266Z"
              fill={color || "#bbb"}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
